import React, { useState, useEffect, useCallback } from 'react'
import {
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Button,
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import decode from 'jwt-decode'

import * as actionType from '../../constants/actionTypes'
import SearchBox from '../SearchBox'
import oyeeah from '../../images/oyeeah.svg'
import useStyles from './styles.js'

const Header = () => {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.user)

  const [userNow, setUserNow] = useState(
    JSON.parse(localStorage.getItem('profile'))
  )

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

  const profile = () => {
    history.push(`/user/${userNow?.result.username}`)
  }
  const logout = useCallback(() => {
    dispatch({ type: actionType.LOGOUT })

    history.push('/login')

    setUserNow(null)
  }, [dispatch, history])

  useEffect(() => {
    const token = userNow?.token

    // JWT
    if (token) {
      const decodedToken = decode(token)

      if (decodedToken.exp * 23000 < new Date().getTime()) logout()
    }

    setUserNow(JSON.parse(localStorage.getItem('profile')))
  }, [location, logout, userNow?.token])

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const mobileMenuId = 'primary-search-account-menu-mobile'
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {!userNow?.result && (
        <MenuItem component={Link} to='/login'>
          <p>Login</p>
        </MenuItem>
      )}
      {userNow?.result && (
        <div>
          <MenuItem color='secondary' onClick={profile}>
            <p>Profile</p>
          </MenuItem>
          <MenuItem color='secondary' onClick={logout}>
            <p>Logout</p>
          </MenuItem>
        </div>
      )}
    </Menu>
  )

  return (
    <div className={classes.grow}>
      <AppBar
        id='app-bar'
        className={classes.appBar}
        color='inherit'
        position='fixed'
      >
        <Link to='/' className={classes.brandContainer}>
          <img className={classes.image} src={oyeeah} alt='OYEEAH' />
        </Link>
        <div className={classes.grow} />
        <SearchBox history={history} location={location} />
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
          {userNow?.result ? (
            <div className={classes.profile}>
              <Button
                onClick={logout}
                variant='contained'
                color='secondary'
                className={classes.logoutButton}
              >
                Logout
              </Button>

              <Avatar
                className={classes.purple}
                alt={userNow?.username}
                src={
                  userNow?.result.username === user?.username
                    ? user?.avatar
                    : userNow?.result.avatar
                }
                onClick={profile}
              >
                {userNow?.result.username.charAt(0)}
              </Avatar>
            </div>
          ) : (
            <div className={classes.leftSideHeader}>
              <Button
                component={Link}
                to='/login'
                variant='contained'
                className={classes.loginButton}
              >
                Login
              </Button>
            </div>
          )}
        </div>
        <div className={classes.sectionMobile}>
          <IconButton
            aria-label='show more'
            aria-controls={mobileMenuId}
            aria-haspopup='true'
            onClick={handleMobileMenuOpen}
            color='inherit'
          >
            <MoreIcon />
          </IconButton>
        </div>
      </AppBar>
      {renderMobileMenu}
    </div>
  )
}

export default Header
